import * as R from 'ramda'

export const hasValue = prop => R.compose(R.not, R.either(R.isEmpty, R.isNil), R.prop(prop))
